var map = {
	"./fig01.jpg": "ffb9",
	"./fig02.jpg": "5cab",
	"./fig03.jpg": "7814",
	"./fig04.jpg": "d130",
	"./fig05.jpg": "8595",
	"./fig06.jpg": "e1da",
	"./fig07.jpg": "a360",
	"./fig08.jpg": "6114",
	"./fig09.jpg": "0e37",
	"./fig10.jpg": "4b2c",
	"./fig11.jpg": "3d82",
	"./fig12.jpg": "b23e",
	"./fig13.jpg": "520e",
	"./fig14.jpg": "f66d",
	"./fig15.jpg": "3f05",
	"./fig16.jpg": "c5c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d2d4";